import { render, staticRenderFns } from "./TabbarBase.vue?vue&type=template&id=61450f8d&scoped=true&"
import script from "./TabbarBase.vue?vue&type=script&lang=ts&"
export * from "./TabbarBase.vue?vue&type=script&lang=ts&"
import style0 from "./TabbarBase.vue?vue&type=style&index=0&id=61450f8d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61450f8d",
  null
  
)

export default component.exports